// Generated by packages/assets/scripts/generate.ts. Do not edit; edit the sources and run pnpm generate.
import type { CatalogDef } from "../src/types.ts";

export const CATALOG: CatalogDef = {
  "families": [
    {
      "name": "spruce",
      "category": "plants",
      "where": "land",
      "sway": "tree",
      "square": false,
      "size": 1,
      "tones": "tree",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 4
    },
    {
      "name": "pine",
      "category": "plants",
      "where": "land",
      "sway": "tree",
      "square": false,
      "size": 1,
      "tones": "tree",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 4
    },
    {
      "name": "birch",
      "category": "plants",
      "where": "land",
      "sway": "tree",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 4
    },
    {
      "name": "snag",
      "category": "plants",
      "where": "land",
      "sway": "tree",
      "square": false,
      "size": 1,
      "tones": "tree",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "juniper",
      "category": "plants",
      "where": "land",
      "sway": "tree",
      "square": false,
      "size": 1,
      "tones": "tree",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 3
    },
    {
      "name": "rowan",
      "category": "plants",
      "where": "land",
      "sway": "tree",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 3
    },
    {
      "name": "oak",
      "category": "plants",
      "where": "land",
      "sway": "tree",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 4
    },
    {
      "name": "bush",
      "category": "plants",
      "where": "land",
      "sway": "grass",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 3
    },
    {
      "name": "fern",
      "category": "plants",
      "where": "land",
      "sway": "grass",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 3
    },
    {
      "name": "tuft",
      "category": "plants",
      "where": "land",
      "sway": "grass",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 4
    },
    {
      "name": "stump",
      "category": "plants",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "windthrow",
      "category": "plants",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "tree",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "log",
      "category": "plants",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "mushroom",
      "category": "plants",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 3
    },
    {
      "name": "reeds",
      "category": "plants",
      "where": "water",
      "sway": "grass",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 3
    },
    {
      "name": "lilypads",
      "category": "plants",
      "where": "water",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 3
    },
    {
      "name": "oats",
      "category": "plants",
      "where": "land",
      "sway": "crop",
      "square": true,
      "size": 1,
      "tones": "crop",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": true,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "barley",
      "category": "plants",
      "where": "land",
      "sway": "crop",
      "square": true,
      "size": 1,
      "tones": "crop",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": true,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "rye",
      "category": "plants",
      "where": "land",
      "sway": "crop",
      "square": true,
      "size": 1,
      "tones": "crop",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": true,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "stooks",
      "category": "plants",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "crop",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": true,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "rock",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 4
    },
    {
      "name": "boulder",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "pebbles",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 2
    },
    {
      "name": "outcrop",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "peak",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "massif",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 2,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "gravhog",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "shipsetting",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 2,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "fornborg",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 2,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "shorestones",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 2
    },
    {
      "name": "driftwood",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "runestone",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 4
    },
    {
      "name": "stones",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "stonecircle",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "cairn",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "kummel",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 2
    },
    {
      "name": "rockcarving",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "cave",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "ruin",
      "category": "stones",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "house",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": true,
      "tap": "tap-house",
      "lines": 0
    },
    {
      "name": "cottage",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": true,
      "tap": "tap-house",
      "lines": 0
    },
    {
      "name": "shed",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "sauna",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "barn",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "longhouse",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": true,
      "tap": "tap-house",
      "lines": 0
    },
    {
      "name": "boathouse",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "fishhut",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "well",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "wellsweep",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "rootcellar",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "smithy",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "fence",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "rengarde",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "woodpile",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "hassja",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "hjell",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "hides",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "laundry",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 3
    },
    {
      "name": "beehive",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "cart",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "church",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "windmill",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "campfire",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 0.5,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 3
    },
    {
      "name": "harbre",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "njalla",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "fabod",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": true,
      "tap": "tap-house",
      "lines": 0
    },
    {
      "name": "goahti",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 0.7,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "lavvu",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 0.7,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "tent",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 0.5,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 3
    },
    {
      "name": "kolmila",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 0.7,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "tjardal",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 0.7,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "huntingtower",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "beacon",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "seamark",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "watermill",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "kastal",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": true,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 2
    },
    {
      "name": "stormannagard",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 2,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": true,
      "tap": "tap-house",
      "lines": 0
    },
    {
      "name": "jetty",
      "category": "houses",
      "where": "water",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 3
    },
    {
      "name": "boat",
      "category": "houses",
      "where": "water",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "faering",
      "category": "houses",
      "where": "water",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "flottning",
      "category": "houses",
      "where": "land",
      "sway": "none",
      "square": true,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-house",
      "lines": 2
    },
    {
      "name": "skogstroll",
      "category": "creatures",
      "where": "any",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 0
    },
    {
      "name": "huldra",
      "category": "creatures",
      "where": "any",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 0
    },
    {
      "name": "bergstroll",
      "category": "creatures",
      "where": "any",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 0
    },
    {
      "name": "jatte",
      "category": "creatures",
      "where": "any",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 0
    },
    {
      "name": "sjotroll",
      "category": "creatures",
      "where": "any",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 0
    },
    {
      "name": "nacken",
      "category": "creatures",
      "where": "any",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": false,
      "animal": false,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-stone",
      "lines": 0
    },
    {
      "name": "deer",
      "category": null,
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": true,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "elk",
      "category": null,
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": true,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "elk",
      "lines": 2
    },
    {
      "name": "reindeer",
      "category": null,
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": true,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 2
    },
    {
      "name": "duck",
      "category": null,
      "where": "water",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": true,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "duck",
      "lines": 2
    },
    {
      "name": "eagle",
      "category": null,
      "where": "land",
      "sway": "none",
      "square": false,
      "size": 1,
      "tones": "plain",
      "smoke": 1,
      "nature": true,
      "animal": true,
      "joins": false,
      "home": false,
      "dwelling": false,
      "tap": "tap-plant",
      "lines": 0
    }
  ],
  "landmarks": {
    "water": [],
    "grass": [
      {
        "within": 196,
        "entries": [
          "iso-campfire-1",
          "iso-campfire-2",
          "iso-harbre-*",
          "iso-cottage-1",
          "iso-cottage-2",
          "iso-cottage-3",
          "iso-cottage-4",
          "iso-house-a1",
          "iso-house-a3",
          "iso-house-a4",
          "iso-house-a5",
          "iso-shed-1",
          "iso-sauna-1",
          "iso-well-1",
          "iso-hassja-*",
          "iso-laundry-*",
          "iso-tent-*"
        ]
      },
      {
        "within": 900,
        "entries": [
          "iso-barn-*",
          "iso-longhouse-*",
          "iso-ruin-2",
          "iso-ruin-4",
          "iso-gravhog-*"
        ]
      },
      {
        "within": null,
        "entries": [
          "iso-church-2",
          "iso-windmill-1",
          "iso-stonecircle-1",
          "iso-ruin-5",
          "iso-fabod-1",
          "iso-kastal-*"
        ]
      }
    ],
    "forest": [
      {
        "within": 625,
        "entries": [
          "iso-ruin-2",
          "iso-runestone-3",
          "iso-woodpile-1",
          "iso-shed-1",
          "iso-campfire-2",
          "iso-campfire-3",
          "iso-kolmila-*",
          "iso-tent-*",
          "iso-tjardal-*",
          "iso-huntingtower-*"
        ]
      },
      {
        "within": null,
        "entries": [
          "iso-ruin-3",
          "iso-stonecircle-1",
          "iso-ruin-5",
          "iso-fabod-1",
          "iso-lavvu-*"
        ]
      }
    ],
    "mountain": [
      {
        "within": 625,
        "entries": [
          "iso-cairn-*",
          "iso-runestone-*",
          "iso-ruin-1",
          "iso-campfire-1",
          "iso-lavvu-*",
          "iso-beacon-*"
        ]
      },
      {
        "within": null,
        "entries": [
          "iso-ruin-3",
          "iso-stonecircle-1",
          "iso-goahti-*",
          "iso-hides-*",
          "iso-njalla-*",
          "iso-rengarde-*",
          "iso-cave-*"
        ]
      }
    ]
  },
  "creatures": {
    "water": [
      "iso-sjotroll-1",
      "iso-sjotroll-2",
      "iso-nacken-1"
    ],
    "grass": [
      "iso-bergstroll-3",
      "iso-jatte-1",
      "iso-jatte-2"
    ],
    "forest": [
      "iso-skogstroll-1",
      "iso-skogstroll-2",
      "iso-huldra-1"
    ],
    "mountain": [
      "iso-bergstroll-1",
      "iso-bergstroll-2",
      "iso-jatte-1",
      "iso-jatte-2"
    ]
  },
  "names": [
    "Styvbjörn",
    "Freja",
    "Torvald",
    "Ingrid",
    "Ragnar",
    "Sigrid",
    "Halvar",
    "Astrid",
    "Gunnar",
    "Ylva",
    "Ulf",
    "Tove",
    "Arne",
    "Gudrun",
    "Sten",
    "Ronja",
    "Leif",
    "Solveig",
    "Björn",
    "Hedda",
    "Ivar",
    "Ragnhild",
    "Torbjörn",
    "Siv",
    "Erland",
    "Inga",
    "Folke",
    "Dagny",
    "Halvdan",
    "Embla",
    "Orm",
    "Gerd",
    "Ture",
    "Alva",
    "Ottar",
    "Tyra",
    "Sune",
    "Valborg",
    "Egil",
    "Runa",
    "Knut",
    "Ingeborg",
    "Harald",
    "Saga",
    "Viggo",
    "Signe",
    "Holger",
    "Liv",
    "Ebbe",
    "Brita"
  ]
};
